import * as React from 'react'
import { useCallback } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { Hint } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import cycleStatusesLaunch from 'modules/compensations/pages/CompensationsPayrollRun/CycleStatusLaunchModal/assets/cycle-statuses-launch.jpg'

type CycleStatusLaunchModalProps = {
  canEditCompensationConcepts: boolean
  payrollRunId: number | undefined
  isPayrollRunTimelineFeatureEnabled: boolean
}

const CycleStatusLaunchModal = ({
  canEditCompensationConcepts,
  payrollRunId,
  isPayrollRunTimelineFeatureEnabled,
}: CycleStatusLaunchModalProps) => {
  const storageKey =
    payrollRunId !== undefined
      ? `${LOCAL_STORAGE_KEYS.compensationsCycleStatusLaunchModalShown}_${payrollRunId}`
      : '__cycle_status_launch_modal_no_run__'
  const [isDismissed, setIsDismissed] = useLocalStorage<boolean>(storageKey, false)

  const alreadySeen = payrollRunId === undefined || isDismissed === true

  const handleDismiss = useCallback(() => {
    if (payrollRunId !== undefined) {
      setIsDismissed(true)
    }
  }, [payrollRunId, setIsDismissed])

  const handleGoToHelpCenter = useCallback(() => {
    handleDismiss()
    window.open(helpCenterUrl('compensations_cycle_statuses'), '_blank', 'noopener,noreferrer')
  }, [handleDismiss])

  const showModal =
    canEditCompensationConcepts &&
    payrollRunId !== undefined &&
    isPayrollRunTimelineFeatureEnabled &&
    !alreadySeen

  if (!showModal) {
    return null
  }

  return (
    <Hint.NewModal onClose={handleDismiss} onFinish={handleDismiss}>
      <Hint.NewModal.ImageStep
        src={cycleStatusesLaunch}
        title={i18n.t('compensations.cycleStatusLaunchModal.title')}
        description={i18n.t('compensations.cycleStatusLaunchModal.description')}
      >
        <Box alignItems="center" justifyContent="center">
          <Button onClick={handleGoToHelpCenter}>
            {i18n.t('compensations.cycleStatusLaunchModal.go_to_help_center')}
          </Button>
        </Box>
      </Hint.NewModal.ImageStep>
    </Hint.NewModal>
  )
}

export default CycleStatusLaunchModal
